import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {MESSAGE, EDIT_MODE} from "../../../../../../wpconfig"

import * as func from "../../../../../../utils/functions";

import * as Actions from "../../../../../../store/modules/resources";
import * as FActions from "../../../../../../store/modules/footer";

import Item from './item'

class MetaForm extends Component {
	constructor(props) {
		super(props);

    this._isMounted = false;

    this.state = {
			isInit: false,
      meta_data: props.meta_data || [],
      editIndex: '',
			pkKey: 'meta_id',
			categoryType: 'scholar_meta_type',
			meta_types: [],
			meta_type_Names: [],
      sortField: null,
      sortOrder: 'asc',
    }
	}

	componentDidMount() {
    this._isMounted = true;

    func.getData("code/search/" + this.state.categoryType, {}).then((response) => {
      if (!this._isMounted) return;

      const t = {}
      t.isInit = true;
      t.meta_types = response.records;
      t["meta_type_Names"] = {}
      response.records.map((r, i) => {
        t["meta_type_Names"][r.code_id] = r.code_name;
      });
      this.setState(t);
    }).catch((error) => {
      console.error('meta_types 로드 실패:', error)
    });

    this.onInsert = this.onInsert.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onRemove = this.onRemove.bind(this);
		this.onEditIndex = this.onEditIndex.bind(this);
		this.showMessage = this.showMessage.bind(this);
    this.handleSort = this.handleSort.bind(this);
	}

  componentDidUpdate(prevProps) {
    if (!this._isMounted) return;

    // props에서 meta_data가 변경되면 state 업데이트
    if (prevProps.meta_data !== this.props.meta_data ||
      prevProps.isMetaInit !== this.props.isMetaInit) {
      this.setState({
        meta_data: this.props.meta_data
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleSort(field) {
    const { sortField, sortOrder } = this.state;
    let newSortOrder = 'asc';

    // 같은 필드를 클릭하면 정렬 순서를 토글
    if (sortField === field) {
      newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
    }

    this.setState({
      sortField: field,
      sortOrder: newSortOrder
    }, () => {
      // getData 호출하여 정렬된 데이터 가져오기
      this.fetchSortedData();
    });
  }

  fetchSortedData() {
    const { sortField, sortOrder } = this.state;
    const params = {
      sort_field: sortField,
      sort_order: sortOrder
    };

    // console.log('fetchSortedData 호출 - params:', params)
    func.getData("admin/scholar/" + func.getParams("record_id") + "/meta", params).then((response) => {
      if (!this._isMounted) return;

      this.setState({
        meta_data: response.record || []
      })
    }).catch((error) => {
      console.error('정렬된 데이터 로드 실패:', error)
    })
  }

  getSortIcon(field) {
    const { sortField, sortOrder } = this.state;
    if (sortField !== field) {
      return '⇅'; // 정렬되지 않은 상태
    }
    return sortOrder === 'asc' ? '↑' : '↓';
  }

  onInsert() {
		const record = this.state.meta_data;

		if (record.length > 0 && record[0][this.state.pkKey] === '') {
			this.showMessage('추가해주세요.')
		} else {
			const insertRecord = {
				"meta_type": "",
				"meta_key": "",
				"meta_a": "",
				"meta_b": "",
				"meta_json": "",
				"scholar_id": "",
        "meta_id": "",
				"is_edit": EDIT_MODE.SHOW_EDIT,
			}
			this.onEditIndex(0);
			// 데이터 변환 체크하기
			record.unshift(insertRecord)
			this.setState({meta_data: record})
		}
	}

	onUpdate(index, item, render) {
		const record = this.state.meta_data
		record[index] = item
		this.setState({meta_data: record})
		if (render)
			this.forceUpdate();
	}

	onRemove(index) {
		const record = this.state.meta_data
		record.splice(index, 1);
		this.setState({meta_data: record})
		this.forceUpdate();
	}

	onEditIndex(id) {
		if (this.state.editIndex === id)
			return;
		if (this.state.editIndex)
			this.refs["ref" + this.state.editIndex].onClose();
		else if (this.refs.ref)
			this.refs.ref.onClose();
		else if (this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();

		this.setState({
			'editIndex': id
		})
	}

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

	onChange = (e) => {
		console.log(e);
	};

	render() {
    if (!this.state.isInit) {
      return ''
    }

		return (
			<>
				<div className="m-0 p-0">
					<h6 className="font-weight-bold align-bottom mt-3 mb-1">메타입력 규칙</h6>
					<ul className="font-size-11">
						<li>HCR, World Top 2%: Title에 연도 입력</li>
						<li>H-index, FWCI: Title에 DB(wos, scopus, kci), V1에 일자(2025.01.01), V2에 값을 입력</li>
						<li>Title 필수. 긴문장은 JSON에 저장. "가나다" → ["가나다"] 형식으로 저장됨.</li>
					</ul>
				</div>
				<div className="d-flex justify-content-end mt-2 mb-1">
					<h6 className="flex-grow-1 font-weight-bold align-bottom mt-3 mb-1" style={{fontSize: "13px"}}>메타 관리</h6>
					<button type="button" className="btn btn-sm btn-outline-dark" onClick={this.onInsert}>추가</button>
				</div>
				<table className="widefat fixed striped editable rm-scholar-meta">
					<thead>
					<tr>
            <th scope="col" onClick={() => this.handleSort('meta_type')} style={{cursor: 'pointer'}}>
              구분 {this.getSortIcon('meta_type')}
            </th>
            <th scope="col" onClick={() => this.handleSort('meta_key')} style={{cursor: 'pointer'}}>
              Title {this.getSortIcon('meta_key')}
            </th>
            <th scope="col">V1</th>
						<th scope="col">V2 / JSON</th>
						<th scope="col">Action</th>
					</tr>
					</thead>
					<tbody>
					{
						this.state.meta_data.map((data, idx) => {
							return (
								<Item
									key={data[this.state.pkKey]}
									index={data[this.state.pkKey]}
									ref={"ref" + data[this.state.pkKey]}
									pkKey={this.state.pkKey}
									arrIndex={idx}
									record={data}
									meta_types={this.state.meta_types}
									meta_type_Names={this.state.meta_type_Names}
									onUpdate={this.onUpdate}
									onRemove={this.onRemove}
									onEditIndex={this.onEditIndex}
									showMessage={this.showMessage}
								/>
							)
						})
					}
					{this.state.meta_data.length <= 0 &&
					<tr className="list-row">
						<td className="column-id-type p-2" colSpan={5}>
							결과가 없습니다.
						</td>
					</tr>
					}
					</tbody>
				</table>
			</>
		)
	}
}

export default connect(
	(state) => ({
		record: state.scholars.record ? state.scholars.record : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(MetaForm)